import CryptoJS from 'crypto-js';
import { Config } from 'shared/lib/config';

/**
 * Encrypt/decrypt helpers for auth tokens stored in localStorage.
 * Decrypt functions live in shared/lib/authUtils.js — this file handles encryption only.
 */

const ENCRYPTION_KEYS = {
  token: Config.REACT_APP_ENCRYPT_KEY_TOKEN,
  refreshToken: Config.REACT_APP_ENCRYPT_KEY_REFRESH_TOKEN,
  email: Config.REACT_APP_ENCRYPT_KEY_EMAIL,
  role: Config.REACT_APP_ENCRYPT_KEY_ROLE,
  user: Config.REACT_APP_ENCRYPT_KEY_USER,
  menus: Config.REACT_APP_ENCRYPT_KEY_MENUS,
  // Company access (company_id + company_features) sourced from GET /me.
  // Falls back to the menus key so environments that have not provisioned
  // REACT_APP_ENCRYPT_KEY_COMPANY keep working.
  company:
    Config.REACT_APP_ENCRYPT_KEY_COMPANY ?? Config.REACT_APP_ENCRYPT_KEY_MENUS,
  // Claim tab/section settings sourced from GET /me `claim_tab_settings`.
  // Falls back to the menus key so environments that have not provisioned
  // REACT_APP_ENCRYPT_KEY_CLAIM_TAB_SETTINGS keep working.
  claimTabSettings:
    Config.REACT_APP_ENCRYPT_KEY_CLAIM_TAB_SETTINGS ??
    Config.REACT_APP_ENCRYPT_KEY_MENUS,
};

const encrypt = (value, key) => CryptoJS.AES.encrypt(value, key).toString();

export const encryptToken = (token) => encrypt(token, ENCRYPTION_KEYS.token);

export const encryptRefreshToken = (refreshToken) =>
  encrypt(refreshToken, ENCRYPTION_KEYS.refreshToken);

export const encryptEmail = (email) => encrypt(email, ENCRYPTION_KEYS.email);

export const encryptRole = (roleData) =>
  encrypt(JSON.stringify(roleData), ENCRYPTION_KEYS.role);

export const encryptUser = (userData) =>
  encrypt(JSON.stringify(userData), ENCRYPTION_KEYS.user);

export const encryptMenus = (menusData) =>
  encrypt(JSON.stringify(menusData), ENCRYPTION_KEYS.menus);

export const encryptCompany = (companyData) =>
  encrypt(JSON.stringify(companyData), ENCRYPTION_KEYS.company);

export const encryptClaimTabSettings = (data) =>
  encrypt(JSON.stringify(data), ENCRYPTION_KEYS.claimTabSettings);
